module.exports = __webpack_public_path__ + "static/media/iconCalendarControlActive.8dc4df89.svg";